

 import * as React from "react";
 import PropTypes from "prop-types";
 import { useStaticQuery, graphql  } from "gatsby";
 import Header from "./header";
 import  "./css/layout.scss"
 import { Helmet } from 'react-helmet'
 import MainMenu from "./MainMenu";
 import Footer from "./footer";
 import { gsap } from "gsap"
 import { useEffect,useContext } from "react";
 import GlobalContext from "../context/GlobalContext"
 import { ScrollTrigger } from "gsap/ScrollTrigger";
 import Aos from 'aos';
import 'aos/dist/aos.css';
import { document } from "browser-monads";
import { useScrollTo } from 'react-use-window-scroll';




 gsap.registerPlugin(ScrollTrigger);



 
 const Layout = ({ children }) => {

  const scrollTo = useScrollTo();


   const data = useStaticQuery(graphql`
     query SiteTitleQuery {
       site {
         siteMetadata {
           title
         }
       }
     }
   `);
   const globalContext = useContext(GlobalContext)
   const {isAvailable,isDrag,closeClass,} = globalContext







   useEffect(() => {
    let cursor = document.querySelector('.cursor')
    let cursorScale = document.querySelectorAll('.cursor-scale')
    let cursorScalep = document.querySelectorAll('.cursor-scalep')
    let Alltext = document.querySelectorAll('h3, h4, h5, h6, li, input, textarea, span, p, a, button, svg, select, .New_news_articles .down')
    let Allbutton = document.querySelectorAll('h2, a, button, .press-list')
    let Allimg = document.querySelectorAll('.Allimg')
    let Allhover = document.querySelectorAll('.Allhover')
    let Allview = document.querySelectorAll('.Allview')
    


 
   let mouseX = 0
    let mouseY = 0

gsap.to({}, 0.016, {
    repeat: -1,

    onRepeat: function () {
        gsap.set(cursor, {
            css: {
                left: mouseX,
                top: mouseY
            }
        })
    }


    
});

window.addEventListener("mousemove", function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY
});

cursorScale.forEach(link => {
    link.addEventListener('mouseleave', () => {
        cursor.classList.remove('grow');
        cursor.classList.remove('grow-small');
    });
    link.addEventListener('mousemove', () => {
        cursor.classList.add('grow');
        if(link.classList.contains('small')){
            cursor.classList.remove('grow');
            cursor.classList.add('grow-small');
        }
    });
});



cursorScalep.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('grow');
      cursor.classList.remove('grow-small');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('grow');
      if(link.classList.contains('small')){
          cursor.classList.remove('grow');
          cursor.classList.add('grow-small');
      }
  });
});


Alltext.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('grow');
      cursor.classList.remove('grow-small');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('grow');
      if(link.classList.contains('small')){
          cursor.classList.remove('grow');
          cursor.classList.add('grow-small');
      }
  });
});

Allbutton.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('grow1');
      cursor.classList.remove('grow-small1');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('grow1');
      if(link.classList.contains('small1')){
          cursor.classList.remove('grow1');
          cursor.classList.add('grow-small1');
      }
  });
});

Allimg.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('grow2');
      cursor.classList.remove('grow-small2');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('grow2');
      if(link.classList.contains('small')){
          cursor.classList.remove('grow2');
          cursor.classList.add('grow-small2');
      }
  });
});


Allhover.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('grow4');
      cursor.classList.remove('grow-small4');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('grow4');
      if(link.classList.contains('small4')){
          cursor.classList.remove('grow4');
          cursor.classList.add('grow-small4');
      }
  });
});

Allview.forEach(link => {
  link.addEventListener('mouseleave', () => {
      cursor.classList.remove('views');
      cursor.classList.remove('grow-views');
  });
  link.addEventListener('mousemove', () => {
      cursor.classList.add('views');
      if(link.classList.contains('views')){
          cursor.classList.remove('views');
          cursor.classList.add('grow-views');
      }
  });
});

}, []);

useEffect(() => {
    Aos.init({duration: 2000});
  }, []);
   return (
     
     <>
      {isAvailable ? <div className="cursor view">{closeClass ? "Close" : "View"}</div> : <div className={isDrag ? "cursor drag": "cursor"}></div>}
      
      
      <div className="layout" >
        
        
       <Header siteTitle={data.site.siteMetadata?.title || `Title`}  />
        <MainMenu/>
       {/* { matches && <div className="gotoTop" onClick={scrollTop}>
       <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 49.5C11.469 49.5 0.500013 38.531 0.500013 25C0.500013 11.469 11.469 0.5 25 0.5C38.531 0.5 49.5 11.469 49.5 25C49.5 38.531 38.531 49.5 25 49.5Z"  stroke="#F68521"/>
<path d="M36.1849 28.9511L25.5495 18.4248L14.9141 28.9511" stroke="#F68521"/>
</svg>
        </div>} */}
      
      
       {children}
      
       <div className="main_footer">
       <Footer/>
       </div>
       <div className="gotoTop" onClick={() => scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
       <svg width="30" height="30" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 49.5C11.469 49.5 0.500013 38.531 0.500013 25C0.500013 11.469 11.469 0.5 25 0.5C38.531 0.5 49.5 11.469 49.5 25C49.5 38.531 38.531 49.5 25 49.5Z"  stroke="#F68521"/>
<path d="M36.1849 28.9511L25.5495 18.4248L14.9141 28.9511" stroke="#F68521"/>
</svg>
      </div>
        </div>
      
       
       
       <Helmet>
       <meta http-equiv="ScreenOrientation" content="autoRotate:disabled"/>
       <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"/>
       <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" /> 
        <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
        <link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css?ver=1.0.0" />
        
       
       </Helmet>
     
     </>
   );
 };
 
 Layout.propTypes = {
   children: PropTypes.node.isRequired,
 };
 
 export default Layout;
 